import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { closeImagePlayer, openImagePlayer } from '../../../Base/Actions';

// import components
import ZoomCanvas from './ZoomCanvas';
import SliderView from '../../Util/Slider/SliderView';
import LoadMore from '../../Util/LoadMore/LoadMoreView';

// Import assets
import './imagePlayer.scss';

import '../../../../assets/icons/Lenspire_Icon_CloseGlobal.svg';
import '../../../../assets/icons/Lenspire_Icon_Plus.svg';
import '../../../../assets/icons/Lenspire_Icon_Minus.svg';

class ImagePlayer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showLoader: true,
    };

    this.canvas = [];
    this.zoomIn = this.zoomIn.bind(this);
    this.zoomOut = this.zoomOut.bind(this);
    this.setSingleSlide = this.setSingleSlide.bind(this);
    this.updateControleSlider = this.updateControleSlider.bind(this);
    this.hideLoader = this.hideLoader.bind(this);
    this.showLoader = this.showLoader.bind(this);
  }

  componentDidMount() {
    if (this.props.isVisible) {
      document.body.classList.add('overflowHidden');
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isVisible) {
      document.body.classList.add('overflowHidden');
    } else {
      document.body.classList.remove('overflowHidden');
    }
  }

  componentWillUnmount() {
    document.body.classList.remove('overflowHidden');
  }

  setSingleSlide(index) {
    if (this.singleSlider) {
      this.singleSlider.slider.slickGoTo(index);
    }
  }

  updateControleSlider() {
    if (this.singleSlider && this.controleSlider) {
      // this.canvas[this.singleSlider.slider.innerSlider.state.currentSlide].resetImage(); // TODO: Does the image have to reset?
      this.controleSlider.slider.slickGoTo(this.singleSlider.slider.innerSlider.state.currentSlide);
    }
  }

  zoomIn() {
    const index = typeof this.singleSlider.slider.innerSlider !== 'undefined' ? this.singleSlider.slider.innerSlider.state.currentSlide : 0;
    if (typeof this.canvas[index] !== 'undefined') {
      this.canvas[index].zoom(1);
    }
  }

  zoomOut() {
    const index = typeof this.singleSlider.slider.innerSlider !== 'undefined' ? this.singleSlider.slider.innerSlider.state.currentSlide : 0;
    if (typeof this.canvas[index] !== 'undefined') {
      this.canvas[index].zoom(-1);
    }
  }

  hideLoader() {
    this.setState({
      showLoader: false,
    });
  }

  showLoader() {
    this.setState({
      showLoader: true,
    });
  }

  render() {
    const singleSliderSettings = {
      centerMode: true,
      infinite: false,
      adaptiveHeight: false,
      variableWidth: true,
      centerPadding: '0px',
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: this.props.initialIndex,
      afterChange: this.updateControleSlider,
      draggable: false,
      swipe: false,
    };

    const controllSliderSettings = {
      centerMode: true,
      infinite: false,
      variableWidth: true,
      centerPadding: '0px',
      slidesToShow: 2,
      slidesToScroll: 1,
      initialSlide: this.props.initialIndex,
    };

    if (this.props.isVisible) {
      return (
        <div className={'m-image-player'}>
          <div className={'m-image-player__controlls'}>
            <div className={'m-image-player__close'} onClick={this.props.closeImagePlayer} role={'button'} tabIndex={-1}>
              <svg>
                <use xlinkHref="#Lenspire_Icon_CloseGlobal" />
              </svg>
            </div>
            <div className={'m-image-player__zoomIn'} onClick={this.zoomIn} role={'button'} tabIndex={-1}>
              <svg>
                <use xlinkHref="#Lenspire_Icon_Plus" />
              </svg>
            </div>
            <div className={'m-image-player__zoomOut'} onClick={this.zoomOut} role={'button'} tabIndex={-1}>
              <svg>
                <use xlinkHref="#Lenspire_Icon_Minus" />
              </svg>
            </div>
          </div>

          <SliderView
            sliderSettings={singleSliderSettings}
            className={'m-image-player__single-image-slider'}
            ref={(singleSlider) => {
              this.singleSlider = singleSlider;
            }}
          >
            {this.props.imagePlayerImages.map((image, index) => (
              <div key={`${image.src.default}`} className={'m-image-player__image slick-slide'}>
                <div className={'m-image-player__pic-wrapper'}>
                  <ZoomCanvas
                    className={'m-image-player__pic'}
                    sources={image.src}
                    alt={image.alt}
                    ref={(ref) => {
                      this.canvas[index] = ref;
                    }}
                    onLoad={this.hideLoader}
                    description={image.desc}
                  />
                </div>
                {(() => {
                  if (!this.state.showLoader) {
                    return null;
                  }

                  return (<LoadMore isLoading />);
                })()}
              </div>
            ))}
          </SliderView>
          {this.props.imagePlayerImages.length > 1 && (
            <SliderView
              sliderSettings={controllSliderSettings}
              className={'m-image-player__controller-slider'}
              ref={(controleSlider) => {
                this.controleSlider = controleSlider;
              }}
            >
              {this.props.imagePlayerImages.map((image, index) => (
                <div
                  key={`${image.src.default}`}
                  className={'m-image-player__image slick-slide'}
                  onClick={() => {
                    this.setSingleSlide(index);
                  }}
                  role={'button'}
                  tabIndex={-1}
                >
                  <img
                    className={'m-image-player__pic'}
                    src={image.src['620']}
                    alt={image.alt}
                  />
                </div>
              ))}
            </SliderView>
          )}
        </div>
      );
    }
    return null;
  }
}

ImagePlayer.propTypes = {
  isVisible: PropTypes.bool,
  imagePlayerImages: PropTypes.arrayOf(PropTypes.shape({})),
  closeImagePlayer: PropTypes.func.isRequired,
  initialIndex: PropTypes.number,
};

ImagePlayer.defaultProps = {
  isVisible: true,
  imagePlayerImages: [],
  initialIndex: 0,
};

function mapStateToProps(state) {
  return {
    ...state.imagePlayerState,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ closeImagePlayer, openImagePlayer }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(ImagePlayer);



// WEBPACK FOOTER //
// ./frontend/js/Components/Globals/ImagePlayer/ImagePlayer.jsx